import { render, staticRenderFns } from "./LiveStage.vue?vue&type=template&id=f94f42dc&scoped=true&"
import script from "./LiveStage.vue?vue&type=script&lang=js&"
export * from "./LiveStage.vue?vue&type=script&lang=js&"
import style0 from "./LiveStage.vue?vue&type=style&index=0&id=f94f42dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94f42dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VIcon,VProgressCircular})
